/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import {
  Box,
  Drawer,
  Hidden,
  List,
  makeStyles,
} from '@material-ui/core'
import NavItem from './NavItem'
// import UserPlate from './UserPlate'
// import LogoIcon from '../../../icons/LogoIcon'
import { roleAccess } from '../../../constants/roleAccess'

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256,
    backgroundColor: '#3a455e',
    borderTopRightRadius: '35px',
    borderBottomRightRadius: '35px',
    '&::-webkit-scrollbar': {
      width: 0,
      display: 'none',
    },
  },
  desktopDrawer: {
    // width: 256,
    backgroundColor: '#3a455e',
    borderTopRightRadius: '35px',
    borderBottomRightRadius: '35px',
    width: 262,
    // top: 54,
    borderLeft: '0',
    borderRight: '0',
    // direction: 'rtl',
    height: '100%',
    // color: red,
    // overflow: 'hidden',
    // width: '100%',
    // height: '100%',
    // paddingRight: '10px',
    // boxSizing: 'content-box',
    '::-webkit-scrollbar': {
      display: 'none',
    },
  },
  dashDrawer: {
    // overflowY: 'scroll',
    width: '100%',
    height: '100%',
    boxSizing: 'content-box',
    // direction: 'rtl',
    // paddingLeft: '10px',
    overflow: 'hidden',
    // paddingLeft: '10px',
    backgroundColor: '#3a455e',
    color: '#ffffff',
    borderTopRightRadius: '35px',
    borderBottomRightRadius: '35px',
    // padding: '40px 0',
    '::-webkit-scrollbar': {
      display: 'none',
    },
  },
  listItems: {
    overflowY: 'scroll',
    paddingLeft: '10px',
    paddingBottom: '55px',
    '&::-webkit-scrollbar': {
      width: 0,
      display: 'none',
    },
  },
}))

const NavBar = ({ onMobileClose, openMobile }) => {
  const classes = useStyles()
  const location = useLocation()
  const userProfile = useSelector((state) => state.user)

  const [dropDown, setDropDown] = useState(false)

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose()
    }
  }, [location.pathname])

  const listItems = useMemo(() => {
    if (userProfile.role?.roleId) return roleAccess[userProfile?.role?.roleId]
    return []
  }, [userProfile])

  // const activeItem = useRef(null)

  // const scrololToActive = (item) => {
  // const wrap = document.querySelector('#wrap')
  // // const acItem = document.querySelector('.item')
  // wrap.scrollTo(0, item.offsetTop + 80)
  // }

  const handleCloseDropDown = () => {
    setDropDown(false)
  }

  const handleOpenDropDown = () => {
    setDropDown(!dropDown)
  }

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      className={classes.dashDrawer}
    >
      <img
        style={{ margin: '35px auto' }}
        src={`${window.location.origin}/images/logo.svg`}
        width="135"
        height="33"
        alt="Login"
      />
      {/* <LogoIcon /> */}

      {/* <UserPlate /> */}

      <Box
        p={2}
        className={classes.listItems}
        id="wrap"
      >
        <List>
          {listItems.map((item) => (
            <>
              <NavItem
                href={item.href}
                key={item.title}
                title={item.title}
                icon={item.icon}
                child={item.children}
                iconTwo={item.iconTwo}
                isParent
                // onClick={() => setDropDown(!dropDown)}
                // setDropDown={setDropDown}
                handleCloseDropDown={handleCloseDropDown}
                handleOpenDropDown={handleOpenDropDown}
                dropDown={dropDown}
                // style={{ whiteSpace: 'nowrap', position: 'relative', height: 'auto' }}
                style={{
                  whiteSpace: 'nowrap',
                  display: 'flex',
                  flexFlow: 'column',
                  justtifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: item.children && dropDown ? '#f4f4f4' : '#3a455e',
                  borderRadius: '24px',
                  color: item.children ? '#3a455e' : '#ffffff',
                  // padding: '0 !important',
                }}
              />

            </>
          ))}
        </List>
      </Box>
      <Box flexGrow={1} />
    </Box>
  )

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  )
}

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
}

NavBar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false,
}

export default NavBar
